import { useParams } from 'react-router-dom'
import { Stack, Title, Group, Select, Badge } from '@mantine/core'
import { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { nodesApi } from '@/api'
import { NodeTable } from '@/components/NodeTable'
import { NodeDetail } from '@/components/NodeDetail'

export function Nodes() {
  const { id } = useParams()
  const [filter, setFilter] = useState<string>('all')

  const { data: nodes = [], isLoading } = useQuery({
    queryKey: ['nodes'],
    queryFn: async () => {
      const { data } = await nodesApi.list()
      return data
    },
    refetchInterval: 10000,
  })

  const filteredNodes = nodes.filter((node) => {
    if (filter === 'all') return true
    if (filter === 'managers') return node.Spec.Role === 'manager'
    if (filter === 'workers') return node.Spec.Role === 'worker'
    if (filter === 'ready') return node.Status.State === 'ready'
    if (filter === 'down') return node.Status.State === 'down'
    return true
  })

  if (id) {
    return <NodeDetail nodeId={id} />
  }

  const readyNodes = nodes.filter((n) => n.Status.State === 'ready').length
  const managerNodes = nodes.filter((n) => n.Spec.Role === 'manager').length
  const workerNodes = nodes.filter((n) => n.Spec.Role === 'worker').length

  return (
    <Stack gap="lg">
      <Group justify="space-between">
        <Title order={2}>Nodes</Title>
        <Group>
          <Badge color="green" variant="light">
            {readyNodes} Ready
          </Badge>
          <Badge color="blue" variant="light">
            {managerNodes} Managers
          </Badge>
          <Badge color="gray" variant="light">
            {workerNodes} Workers
          </Badge>
        </Group>
      </Group>

      <Select
        placeholder="Filter nodes"
        data={[
          { value: 'all', label: 'All nodes' },
          { value: 'managers', label: 'Managers only' },
          { value: 'workers', label: 'Workers only' },
          { value: 'ready', label: 'Ready nodes' },
          { value: 'down', label: 'Down nodes' },
        ]}
        value={filter}
        onChange={(value) => setFilter(value || 'all')}
        w={200}
      />

      <NodeTable nodes={filteredNodes} loading={isLoading} />
    </Stack>
  )
}